import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';
import GoalDetailScreen from 'src/sections/home/goal-detail';

// ----------------------------------------------------------------------

const metadata = { title: `Goal Detail |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <GoalDetailScreen />
    </>
  );
}
